import MenuEntityConfiguration from '../entityConfigs/index.js';
import categoryConfig from './category.js';
import couponConfig from './coupon.js';
import itemConfig from './item.js';
import menuConfig from './menu.js';
import modifierConfig from './modifier.js';
import modifierSetConfig from './modifierSet.js';
const allConfigurations = {
    Category: categoryConfig,
    Coupon: couponConfig,
    Item: itemConfig,
    Menu: menuConfig,
    Modifier: modifierConfig,
    ModifierSet: modifierSetConfig,
};
export const PROVIDED_CONFIGURATIONS = {
    Category: categoryConfig.config,
    Coupon: couponConfig.config,
    Item: itemConfig.config,
    Menu: menuConfig.config,
    Modifier: modifierConfig.config,
    ModifierSet: modifierSetConfig.config,
};
export default {
    Category: new MenuEntityConfiguration(categoryConfig, allConfigurations),
    Coupon: new MenuEntityConfiguration(couponConfig, allConfigurations),
    Item: new MenuEntityConfiguration(itemConfig, allConfigurations),
    Menu: new MenuEntityConfiguration(menuConfig, allConfigurations),
    Modifier: new MenuEntityConfiguration(modifierConfig, allConfigurations),
    ModifierSet: new MenuEntityConfiguration(modifierSetConfig, allConfigurations),
};
//# sourceMappingURL=index.js.map